

<div [hidden]="!show">
    <div class="progress-loader"></div>
</div>